// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Jpg8","label":"styles_label__2smQO"};